<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MenuItem from 'dashboard/components/widgets/conversation/contextMenu/menuItem.vue';

const props = defineProps({
  isGroupChat: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['rename', 'delete']);

const { t } = useI18n();

const renameOption = computed(() => ({
  label: t('STAFF_CHAT.RENAME_GROUP'),
  icon: 'edit',
}));

const deleteOption = computed(() => ({
  label: props.isGroupChat
    ? t('STAFF_CHAT.LEAVE_GROUP')
    : t('STAFF_CHAT.DELETE_CHAT'),
  icon: 'delete',
}));
</script>

<template>
  <div
    class="p-1 rounded-md shadow-xl bg-n-alpha-3/50 backdrop-blur-[100px] outline-1 outline outline-n-weak/50"
  >
    <MenuItem
      v-if="isGroupChat"
      :option="renameOption"
      variant="icon"
      @click.stop="$emit('rename')"
    />
    <hr
      v-if="isGroupChat"
      class="m-1 rounded border-b border-n-weak dark:border-n-weak"
    />
    <MenuItem
      :option="deleteOption"
      variant="icon"
      @click.stop="$emit('delete')"
    />
  </div>
</template>
